import React from "react";
import PageHeading from "../shared/PageHeading";
import Spacer from "../shared/Spacer";
import UnderstandingChakras from "../sections/reiki/UnderstandingChakras";
import HowReikiWorks from "../sections/reiki/HowReikiWorks";
import ReikiBenefits from "../sections/reiki/ReikiBenefits";
import EnergyFlow from "../sections/reiki/EnergyFlow";
import DistanceReiki from "../sections/reiki/DistanceReiki";
import Footer from "../shared/Footer";

const WhatIsReiki = () => {
	return (
		<div>
			<PageHeading heading="What is Reiki?" />
			{/* Spacer to push content below the fixed header */}
			<div style={{ height: '30vh' }}></div>
			<div className="content-wrapper" style={{ 
				position: 'relative', 
				zIndex: 10, 
				backgroundColor: 'white',
				minHeight: '100vh'
			}}>
				<div className="d-none d-md-block">
					<Spacer />
				</div>
				<div className="my-5">
					<UnderstandingChakras />
				</div>
				<Spacer />
				<HowReikiWorks />
				<div className="bg-brand-gradient">
					<Spacer />
					<ReikiBenefits />
					<Spacer />
				</div>
				<Spacer />
				<EnergyFlow />
				<Spacer />
				<Spacer />
				<DistanceReiki />
				<Spacer />
				<Footer />
			</div>
		</div>
	);
};

export default WhatIsReiki;
